/*
Loons Lab Main Container component
Developed By Roshan
Loons Lab
*/
import { Height } from "@material-ui/icons";
import React, { Fragment, useState, Component } from "react";
class MainContainer extends Component {
    static propTypes = {
        children: Node,
    };

    static defaultProps = {
        title: null,

    };



    render() {
        const {
            children
        } = this.props;


        return (

            // <div className="pb-24 pt-2 px-main-8 " style={{  
            <div className="pb-8 pt-8 px-main-8 " style={{  
                // backgroundImage: "url(" + "https://images.pexels.com/photos/808510/pexels-photo-808510.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" + ")",
                // backgroundImage: '/assets/home-bg-black.png',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                background: "linear-gradient(320deg,rgba(213,226,237,1),rgba(213,226,237,1))",
                height: '100%'
            }}
            >
                {children}
            </div>


        );
    }
}

export default MainContainer;